import React from 'react';
import { categoryAPI } from "../../../../Redux/services/CategoryService";
import { useNavigate } from "react-router-dom";
import {publicationAPI} from "../../../../Redux/services/PublicationService";

const CategoryCard = () => {
    const { data } = publicationAPI.useFetchAllCategoriesQuery('');
    const navigate = useNavigate();

    const navigateToPublication = (id: number) => {
        navigate(`/publications/${id}`);
    };

    return (
        <div className="flex flex-col items-center px-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-[1400px]">
                {data && data.map((item: any) => (
                    <div
                        key={item.id}
                        onClick={() => navigateToPublication(item.id)}
                        className="relative bg-[#f9f9f9] w-full aspect-[3/1] flex items-center justify-center rounded-2xl border border-gray-300 shadow-sm cursor-pointer hover:shadow-md transition"
                    >
                        <span className="text-[#4573c4] text-xl font-medium text-center px-4">
                            {item.title}
                        </span>

                        {item.unread_count > 0 && (
                            <span className="absolute -top-2 -right-2 bg-red-200 border-2 border-red-500 text-red-600 text-sm w-7 h-7 rounded-full flex items-center justify-center font-semibold">
                                {item.unread_count}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoryCard;
